import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  TableCellComponent,
  TableCellActionComponent,
  TableCellCountComponent,
  TableCellLinkComponent,
  TableCellMultiLineComponent
} from './TableCell.component'

import { CheckboxWrapperSpan, OpenSubRow, DataFlag } from './TableCell.styles'
import CustomCheckBox from '../../../checkbox'
import TableRowActionsContainer from '../tablerowactions/TableRowActions.container'
import Formatter from '../../utils/formatters'
import {Icon} from '../../../../shared/tr-icons'

class TableCellContainer extends Component {
  static propTypes = {
    showToolTip: PropTypes.bool,
    count: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props)

    this.subRef = null
    this.subRowOpen = false
    this.formatter = new Formatter()

    this.state = {
      zIndex: 0
    }
  }

  captureSubRef = (ref) => {
    this.subRef = ref
  }

  componentDidMount() {
    if(this.props.cellFormatter && this.props.showToolTip) {
      this.forceUpdate();
    }
  }

  handleLinkClick = () => {
    this.props.analytics.propagateEvent({
      eventType: 'click',
      label: this.props.dataItem,
      action: 'data cell link',
      type: 'Data Table'
    })
  }

  /**
   * @description - adjust z-index on mouse rollover of tooltip
   */
  handleMouseEntered = () => {
    this.setState({
      zIndex: 15
    })
  }

  /**
   * @description - adjust z-index on mouse rollover of tooltip
   */
  handleMouseLeft = () => {
    this.setState({
      zIndex: 0
    })
  }

  /**
   *
   * @param {Event} evt
   *
   * @description Handle multiselect check/uncheck
   */
  handleMultiSelectChanged = (checkStatus) => {
    this.props.handleMultiSelectChanged(!checkStatus)

    this.props.analytics.propagateEvent({
      eventType: 'check changed',
      label: this.props.dataItem.toString(),
      checkedState: !checkStatus,
      action: 'Row check box',
      type: 'Data Table'
    })
  }

  /**
   *
   * @param {Boolean} evt
   *
   * @description Handle sub row open/close
   */
  handleSubRowChanged = (evt) => {
    this.subRowOpen = !this.subRowOpen

    this.props.analytics.propagateEvent({
      eventType: 'click',
      action: 'Toggle Sub Row',
      type: 'Datatable'
    })

    this.props.handleSubRowChanged(this.subRowOpen)
  }

  /**
   * Assemble multiselect checkbox
   */
  buildMultiSelect() {
    const checkboxPropsNormal = {
      'name': 'TableCellCheckBox',
      'disableProperty': false,
      'partialCheckbox': false,
      'boxStatus': (this.props.multiselected) ? 'selected' : 'default',
      'requiredProperty': false,
      'checkStatus': this.handleMultiSelectChanged
    }
    
    const checkboxPropsDisabled = {
      "name": "TableCellCheckBox",
      "disableProperty": true,
      "partialCheckbox": false,
      "boxStatus": "disabledSelected",
      "requiredProperty": false
    }

    // headerChecked means: The select-all checkbox is checked
    // In this case the individual checkboxes are checked and *disabled* - seems weird but it's a requirement (MYA-20311)
    const isDisabled = this.props.headerChecked
    const checkboxProps = isDisabled ? checkboxPropsDisabled : checkboxPropsNormal

    let output = null

    if (this.props.multiselect && this.props.count === 0) {
      if (this.props.multiselectenabled) {
        output = (<CheckboxWrapperSpan disabled={isDisabled} className='tableheaderCheckbox'><CustomCheckBox {...checkboxProps}/></CheckboxWrapperSpan>)
      } else {
        output = (<span style={{ display: 'inline-block', 'width': '20px', marginLeft: '10px' }} />)
      }
    }

    return output
  }

  /**
   * @description Assemble SVG icon for open direction
   */
  buildCaret() {
    if (!this.subRowOpen) {
      return <Icon type='caretDown' />
    } else {
      return <Icon type='caretUp' />
    }
  }

  /**
   * @description Assemble left flag styling
   */
  buildFlag() {
    let output = null

    if (this.props.rowFlag && this.props.count === 0) {
      let flag = null

      if (this.props.rowFlag && this.props.rowFlag.comparator && this.props.env.checkFunction(this.props.rowFlag.comparator)) {
        flag = this.props.env.callFunction(this.props.rowFlag.comparator, [this.props.dataRow])
      }

      if (flag) {
        output = <DataFlag style={{ backgroundColor: flag }} />
      }
    }

    return output
  }

  /**
   * @description Assemble sub row arrow up/down
   */
  buildSubRow() {
    let output = null

    if (this.props.subRows && this.props.count === 0) {
      if (this.props.subRows.subRowData) {
        output = (<OpenSubRow onClick={this.handleSubRowChanged}>{
          this.buildCaret()
        }</OpenSubRow>)
      } else {
        output = (<OpenSubRow />)
      }
    }

    if (this.props.isSubRow && this.props.count === 0) {
      output = (<OpenSubRow />)
    }

    return output
  }
  /**
   *
   * @param {*} dataItem
   *
   */
  getDataItem(dataItem) {
    if (this.props.isActionCell) {
      return (
        <TableRowActionsContainer 
          multiselected={this.props.multiselected}
          analytics={this.props.analytics} 
          selectedRows={this.props.selectedRows} 
          dataItem={this.props.dataItem} 
          env={this.props.env} 
          dataRow={this.props.dataRow} />
      )
    }

    return dataItem
  }

  /**
   * @description assemble injected labels and on the fly styling
   */
  buildSubStyling() {
    let output = {
      label: {
        content: '',
        styling: {}
      },
      styling: {}
    }

    if (this.props.cellFormatter && this.props.cellFormatter.comparator && this.props.env.checkFunction(this.props.cellFormatter.comparator)) {
      output = this.props.env.callFunction(this.props.cellFormatter.comparator, [this.props.dataRow, this.props.header.datafield]) || output
    }

    return output
  }

  buildCellLink() {
    let output = ''

    if (this.props.header.cellLink && this.props.header.cellLink.callback && this.props.env.checkFunction(this.props.header.cellLink.callback)) {
      output = this.props.env.callFunction(this.props.header.cellLink.callback, [this.props.dataRow])
    }

    return output
  }

  render() {
    let freezeColOffset = -1

    if (this.props.freezeCol) {
      freezeColOffset = 0
    }

    // left: (this.props.count > freezeColOffset) ? (0 - this.props.scrollOffset) : 0
    const value = (this.props.count > freezeColOffset) ? (0 - this.props.scrollOffset) : 0
    const style = {
      transform: 'translate(' + value + 'px)'
    }

    if (this.state.zIndex > 0) {
      style.zIndex = this.state.zIndex
    }

    const classNames = []

    if (this.props.isSubRow) {
      classNames.push('sub-row')
    }

    if (this.props.freezeCol) {
      classNames.push('frozen-cell')
    }

    const subStyling = this.buildSubStyling()

    let dataItem = this.getDataItem(this.props.dataItem)

    const events = {
      handleMouseEntered: this.handleMouseEntered,
      handleMouseLeft: this.handleMouseLeft,
      handleMouseClick: this.handleMouseClick,
      captureSubRef: this.captureSubRef,
      handleLinkClick: this.handleLinkClick
    }

    if (dataItem && dataItem.type) {
      // we have an actions cell
  

      return (
        <TableCellActionComponent 
          env={this.props.env} 
          analytics={this.props.analytics} 
          dataItem={dataItem} 
          className={classNames.join(' ')}
          multiselected={this.props.multiselected}
          style={style} />
      )
    }

    if (this.props.header.displayFormat) {
      if (Array.isArray(dataItem)) {
        dataItem = dataItem.map((item, i) => {
          if (item.length > 0) {
            return this.formatter.doFormat(item, this.props.header.displayFormat)
          }
          return item
        })
      } else {
        dataItem = this.formatter.doFormat(dataItem, this.props.header.displayFormat)
      }
    }
    // should we be overriding the cell contents with a sub row count?
    if (this.props.header.subRowOverride && this.props.header.subRowOverride.enabled) {
      if (this.props.subRows && this.props.subRows.subRowData && this.props.subRows.subRowData.length > 0) {
        return (<TableCellCountComponent count={this.props.subRows.subRowData.length} style={style} />)
      }
    }

    if (Array.isArray(dataItem) && this.props.dataRow && this.props.dataRow.showMultiLine === "true") {
      return (
        <TableCellMultiLineComponent
          flag={this.buildFlag()}
          className={classNames.join(' ')}
          style={style}
          dataItem={dataItem}
          dataItemStyle={this.props.dataItemStyle}
          subStyling={subStyling}
          showToolTip={this.props.showToolTip}
          lastColumn={this.props.lastColumn}
          firstColumn={this.props.firstColumn}
          count={this.props.count}
          events={events}
          dataRow={this.props.header.cellLink && this.props.header.cellLink.enabled && this.props.dataRow}
          env={this.props.header.cellLink && this.props.header.cellLink.enabled && this.props.env}
          link={this.props.header.cellLink && this.props.header.cellLink.enabled && this.buildCellLink()}
          analytics={this.props.analytics}
        >
          {this.buildMultiSelect()}
          {this.buildSubRow()}
        </TableCellMultiLineComponent>
      )
    }

    if (this.props.header.cellLink && this.props.header.cellLink.enabled) {
      return (
        <TableCellLinkComponent
          flag={this.buildFlag()}
          className={classNames.join(' ')}
          style={style} dataItem={dataItem}
          subStyling={subStyling}
          dataRow={this.props.dataRow}
          env={this.props.env}
          link={this.buildCellLink()}
          events={events}
          showToolTip={this.props.showToolTip}
          lastColumn={this.props.lastColumn}
          firstColumn={this.props.firstColumn}
          analytics={this.props.analytics}         
        >
          {this.buildMultiSelect()}
          {this.buildSubRow()}
        </TableCellLinkComponent>
      )
    }

    return (
      <TableCellComponent
        isActionCell={this.props.isActionCell}
        flag={this.buildFlag()}
        className={classNames.join(' ')}
        style={style} dataItem={dataItem}
        subStyling={subStyling}
        width={this.props.header.width || 200}
        showToolTip={this.props.showToolTip}
        lastColumn={this.props.lastColumn}
        firstColumn={this.props.firstColumn}
        count={this.props.count}
        events={events}
        subRef={this.subRef}
        analytics={this.props.analytics}
      >
        {this.buildMultiSelect()}
        {this.buildSubRow()}
      </TableCellComponent>
    )
  }
}

export default TableCellContainer
